const REDIRECTR_PERMISSIONS_TOAST = 1;
const REDIRECTR_TERMS_DECLINED_TOAST = 2;

class Redirectr
{
    /**
     * Create a new Redirectr instance.
     * 
     * @param {Route} route 
     */
    constructor(route)
    {
        this.route = route;
        this.redirectTo = route.query ? route.query.redirectTo : null;
        this.messageType = route.query ? parseInt(route.query.message) : null;
    }

    /**
     * Check whether the redirectTo param exists.
     * 
     * @return {Boolean}
     */
    hasRedirect()
    {
        return this.redirectTo ? true : false;
    }

    /**
     * Check whether the message param exists.
     * 
     * @return {Boolean}
     */
    hasMessage() {
        return this.messageType ? true : false;
    }

    /**
     * Get the URL of the app that the user will be redirected to.
     * 
     * @return {String}
     */
    getRedirectUrl() 
    {
        return `${process.env.VUE_APP_REDIRECT_BASE_URL}/${this.redirectTo}`;
    }

    /**
     * Add the redirection details to a given url.
     * 
     * @param {String} url
     * 
     * @return {String}
     */
    addRedirectionDetailsToUrl(url)
    {
        url += "?";
        if(this.hasRedirect())
            url += `&redirectTo=${this.redirectTo}`;
        if(this.hasMessage())
            url += `&message=${this.messageType}`;
        return url;
    }

    /**
     * Get the message as an object.
     * 
     * @return {Object}
     */
    getMessageAsObject() 
    {
        switch(this.messageType) {
            case REDIRECTR_PERMISSIONS_TOAST:
                return { 
                    type: "warning", 
                    title: "Warning", 
                    titleDe: "Warning (DE)", 
                    description: "You do not have the right permissions to access the specified resource.",
                    descriptionDe: "You do not have the right permissions to access the specified resource. (DE)" 
                };
            case REDIRECTR_TERMS_DECLINED_TOAST:
                return {
                    type: "info",
                    title: "Terms Declined",
                    titleDe: "Terms Declined",
                    description: "You must accept the terms in order to access the specified resource",
                    descriptionDe: "You must accept the terms in order to access the specified resource"
                };
            default:
                return null;
        }
    }
}

export default Redirectr;